<ng-container *ngIf="!pageMode then main">
</ng-container>

<div class="ion-page full-screen-height" *ngIf="pageMode">
  <ng-container *ngIf="true then main"></ng-container>
</div>

<ng-template #main>
  <ion-header #header>
    <ion-toolbar color="light">
      <ion-buttons slot="start">
        <ion-button (click)="back()">
          <ion-icon class="back-icon" name="chevron-back"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
        <app-offline-indicator></app-offline-indicator>
        {{ (newMode ? 'SUPPORT.lbl.title.new' : 'SUPPORT.lbl.title.current') | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content color="light" #content>
    <div class="content-div">
      <ng-container *ngIf="!supportTicket?.ticketId">
        <div *ngIf="!ticketType">
          <div class="ion-padding-bottom">
            <div class="ion-text-center ion-margin">
              <ion-text class="font-18 font-med" color="dark">{{ 'CONTACT.msg.title' | translate }}</ion-text>
            </div>
            <div class="ion-text-center ion-margin">
              <ion-text class="font-14" color="dark">{{ 'CONTACT.msg.support' | translate }}</ion-text>
            </div>
          </div>
          
          <div class="ion-margin ion-padding-vertical">
            <ion-grid>
              <ion-row>
                <ion-col>
                  <ion-card class="ion-padding ion-no-margin ion-text-center" (click)="setTicketType('inquiry')" button>
                    <ion-icon class="center font-34" name="help-circle-outline"></ion-icon>
                    <div>
                      <ion-text class="font-12 font-semi" color="dark">{{ 'SUPPORT.list.type.inquiry' | translate }}</ion-text>
                    </div>
                  </ion-card>
                </ion-col>
                <ion-col>
                  <ion-card class="ion-padding ion-no-margin ion-text-center" (click)="setTicketType('feedback')" button>
                    <ion-icon class="center font-34" name="chatbox-ellipses-outline"></ion-icon>
                    <div>
                      <ion-text class="font-12 font-semi" color="dark">{{ 'SUPPORT.list.type.feedback' | translate }}</ion-text>
                    </div>
                  </ion-card>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-card class="ion-padding ion-no-margin ion-text-center" (click)="setTicketType('bug')" button>
                    <ion-icon class="center font-34" name="alert-circle-outline"></ion-icon>
                    <div>
                      <ion-text class="font-12 font-semi" color="dark">{{ 'SUPPORT.list.type.bug' | translate }}</ion-text>
                    </div>
                  </ion-card>
                </ion-col>
                <ion-col>
                  <ion-card class="ion-padding ion-no-margin ion-text-center" (click)="setTicketType('refund')" button>
                    <ion-icon class="center font-34" name="arrow-back-circle-outline"></ion-icon>
                    <div>
                      <ion-text class="font-12 font-semi" color="dark">{{ 'SUPPORT.list.type.refund' | translate }}</ion-text>
                    </div>
                  </ion-card>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        
          <div class="ion-margin-vertical ion-padding-vertical">
            <div class="ion-text-center">
              <ion-text class="font-14 font-med" color="dark">{{ 'CONTACT.msg.connect' | translate }}</ion-text>
            </div>
            
            <ion-grid class="full-width">
              <ion-row>
                <ion-col class="ion-align-self-center">
                  <ion-icon class="center icon-large" name="logo-facebook" color="dark" (click)="open('facebook')"></ion-icon>
                </ion-col>
                <ion-col class="ion-align-self-center">
                  <ion-icon class="center icon-large" name="logo-instagram" color="dark" (click)="open('instagram')"></ion-icon>
                </ion-col>
                <ion-col class="ion-align-self-center">
                  <ion-icon class="center icon-large" name="logo-youtube" color="dark" (click)="open('youtube')"></ion-icon>
                </ion-col>
                <ion-col class="ion-align-self-center">
                  <ion-icon class="center icon-large" name="mail-outline" color="dark" (click)="open('email')"></ion-icon>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </div>
        <form class="ion-padding-horizontal" [formGroup]="supportForm" (ngSubmit)="supportFormSubmit()" *ngIf="ticketType && supportForm">
    
          <ng-container  *ngIf="ticketType">
            <div class="ion-padding-bottom"><ion-text class="font-12">{{ 'SUPPORT.intro.' + ticketType | translate }}</ion-text></div>
            <div class="ion-margin-vertical">
              <ion-item class="account-item background-transparent ion-item-no-padding" lines="none">
                <ion-label position="stacked">{{ 'SUPPORT.account.' + ticketType | translate }} <ion-text color="danger" *ngIf="ticketType === 'refund'">*</ion-text></ion-label>
                <ion-item class="prompt-input-item" lines="none" (click)="presentAccountsListModal()">
                  <ion-label class="ion-no-margin" >{{ getAccountTitle(supportForm.value.accountId) }}</ion-label>
                  <ion-note slot="end"><ion-icon name="chevron-down" class="font-18"></ion-icon></ion-note>
                </ion-item>
                <div class="error-div">
                </div>
              </ion-item>
            </div>
            
            <ion-item class="background-transparent ion-item-no-padding ion-margin-vertical" lines="none">
              <ion-label position="stacked">{{ 'SUPPORT.msg.' + ticketType | translate }} <ion-text color="danger">*</ion-text></ion-label>
              <ion-item class="prompt-input-item" lines="none">
                <ion-textarea class="text-area" formControlName="msg" rows="5" autoGrow="true"></ion-textarea>
              </ion-item>
              <div class="error-div">
              </div>
            </ion-item>
      
            <ion-item class="background-transparent ion-item-no-padding" lines="none">
              <ion-label class="ion-text-wrap" position="stacked">{{ 'SUPPORT.attachment.' + ticketType | translate }}</ion-label>
              <ion-card class="prompt-input-item full-width ion-no-margin">
                <ion-grid fixed>
                  <ion-row>
                    <ng-container *ngIf="getSupportAttachmentList() as photoList">
                      <ion-col size="3" *ngFor="let photo of photoList; let i = index;">
                        <div class="attachment-img-div">
                          <ion-button class="attachment-img-btn" (click)="deletePhoto(i);" fill="clear" color="dark">
                            <ion-icon slot="icon-only" name="close"></ion-icon>
                          </ion-button>
                          <ion-img class="attachment-img center" [src]="photo"></ion-img>
                        </div>
                      </ion-col>
                    </ng-container>
                    <ion-col class="vertical-center">
                      <ion-item class="full-width-height ion-no-margin ion-item-no-padding upload-item" color="light" lines="none" (click)="selectPhoto()" [detail]="false">
                        <ion-label class="ion-text-center">
                          <ion-img class="center upload-img" name="cloud-upload-outline"></ion-img>
                          <div class="ion-text-center font-12 font-semi">{{ 'VISITOR.setting.background.upload' | translate }}</div>
                        </ion-label>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </ion-item>
          </ng-container>
        </form>
      </ng-container>
    
      <ng-container *ngIf="supportTicket?.ticketId">
        <ion-item class="info-item" color="tertiary" lines="none">
          <ion-label>
            <div>
              <ion-text class="font-14 font-bold">
                <span *ngIf="supportTicket?.ticketType">{{ ('SUPPORT.list.type.' + supportTicket.ticketType) | translate }}</span>
                <span *ngIf="supportTicket?.ticketType && supportTicket?.ticketStatus">&nbsp;</span>
                <span *ngIf="supportTicket?.ticketStatus">[{{ ('SUPPORT.list.status.' + supportTicket.ticketStatus) | translate }}]</span>
              </ion-text>
            </div>
            <div *ngIf="supportTicket?.accountId">
              <ion-text class="font-12"><ion-icon src="./assets/wedding/icon/general/flag.svg"></ion-icon> {{ getAccountTitle(supportTicket.accountId) }} </ion-text>
            </div>
            <div *ngIf="supportTicket?.createBy?.time">
              <ion-text class="font-10"><ion-icon name="time-outline"></ion-icon> {{ format(supportTicket.createBy.time) }} </ion-text>
            </div>
            <div>
              <ion-text class="font-10"><ion-icon name="ticket-outline"></ion-icon> {{ supportTicket.ticketId }} </ion-text>
            </div>
          </ion-label>
        </ion-item>
        <div *ngIf="messagesList?.length">
          <ion-list class="background-transparent ion-padding-bottom" lines="none" #list>
            <ng-container *ngFor="let date of dateList">
              <ng-container *ngIf="msgList?.[date]?.length">
                <ng-container>
                  <ion-item-group>
                    <ion-item-divider class="ion-margin-vertical" color="light">
                      <div class="full-width ion-text-center">
                        <ion-label class="font-bold font-12">{{ date }}</ion-label>
                      </div>
                    </ion-item-divider>
                  
                    <div>
                      <ng-container *ngFor="let message of msgList[date];">
                        <ion-item class="background-transparent" lines="none">
                          <ion-card class="msg-card ion-padding" [color]="message?.createBy?.uid === 'admin' ? 'white' : 'secondary'" [slot]="message.createBy.uid === 'admin' ? 'start' : 'end'">
                            <ng-container *ngIf="message?.attachments?.length">
                              <ion-grid fixed>
                                <ion-row>
                                  <ion-col *ngFor="let attachment of message.attachments;">
                                    <ion-img class="img-thumbnail" [src]="attachment"></ion-img>
                                  </ion-col>
                                </ion-row>
                              </ion-grid>
                            </ng-container>
                            <div>
                              <ion-text class="html-div wrap-newline" *ngIf="message?.message" [innerHTML]="getHtml(message.message)"></ion-text>
                            </div> 
                            <div class="font-10 ion-text-right">
                              <ion-text color="medium">
                                {{ format(message?.createBy?.time, 'time') }}
                              </ion-text>
                            </div>
                          </ion-card>
                        </ion-item>
                        <ng-container *ngIf="message?.messageId === supportTicket.primaryMessageId">
                          <ion-item class="background-transparent" lines="none">
                            <ion-card class="msg-card ion-padding" slot="start">
                              <div>
                                <ion-text [innerHTML]="'SUPPORT.auto_reply.' + supportTicket.ticketType | translate: { name: supportTicket?.name ? supportTicket.name : '' }"></ion-text>
                              </div>
                              <div class="font-10 ion-text-right">
                                <ion-text color="medium">
                                  {{ format(supportTicket?.createBy?.time, 'time') }}
                                </ion-text>
                              </div>
                            </ion-card>
                          </ion-item>
    
                          <ion-item class="background-transparent" lines="none" (click)="goHelpCenter()">
                            <ion-card class="msg-card ion-padding" button slot="start">
                              <div>
                                <ion-text [innerHTML]="'SUPPORT.help_center' | translate"></ion-text>
                              </div>
                              <div class="font-10 ion-text-right">
                                <ion-text color="medium">
                                  {{ format(supportTicket?.createBy?.time, 'time') }}
                                </ion-text>
                              </div>
                            </ion-card>
                          </ion-item>
    
                          <ion-item class="background-transparent" lines="none" *ngIf="permissionStatus && permissionStatus !== 'granted'">
                            <ion-card class="msg-card ion-padding" (click)="requestPermission()" color="primary" slot="start">
                              <div [ngClass]="permissionStatus !== 'denied' ? '' : ''">
                                <ng-container *ngIf="permissionStatus === 'denied' else requestPermissionBlock"><ion-text [innerHTML]="'INBOX.permission.denied' | translate"></ion-text></ng-container>
                                <ng-template #requestPermissionBlock><ion-text [innerHTML]="'INBOX.permission.request' | translate"></ion-text></ng-template>
                              </div>
                              <div class="font-10 ion-text-right">
                                <ion-text color="medium">
                                  {{ format(supportTicket?.createBy?.time, 'time') }}
                                </ion-text>
                              </div>
                            </ion-card>
                          </ion-item>
    
                        </ng-container>
                      </ng-container>
                    </div>
                  </ion-item-group>
                </ng-container>
              </ng-container>
            </ng-container>
    
            <div class="ion-margin" *ngIf="supportTicket?.ticketStatus !== 'in_progress'">
              <div class="ion-text-center">
                <ion-text class="font-14">
                  {{ 'SUPPORT.rating.msg' | translate }}
                </ion-text>
              </div>
              <ion-grid fixed>
                <ion-row class="ion-align-items-center ion-justify-content-center">
                  <ion-col (click)="updateTicketRating('one')">
                    <ion-icon class="center" [color]="starColor" name="star-outline" *ngIf="!star?.one"></ion-icon>
                    <ion-icon class="center" [color]="starColor" name="star" *ngIf="star?.one"></ion-icon>
                  </ion-col>
                  <ion-col (click)="updateTicketRating('two')">
                    <ion-icon class="center" [color]="starColor" name="star-outline" *ngIf="!star?.two"></ion-icon>
                    <ion-icon class="center" [color]="starColor" name="star" *ngIf="star?.two"></ion-icon>
                  </ion-col>
                  <ion-col (click)="updateTicketRating('three')">
                    <ion-icon class="center" [color]="starColor" name="star-outline" *ngIf="!star?.three"></ion-icon>
                    <ion-icon class="center" [color]="starColor" name="star" *ngIf="star?.three"></ion-icon>
                  </ion-col>
                  <ion-col (click)="updateTicketRating('four')">
                    <ion-icon class="center" [color]="starColor" name="star-outline" *ngIf="!star?.four"></ion-icon>
                    <ion-icon class="center" [color]="starColor" name="star" *ngIf="star?.four"></ion-icon>
                  </ion-col>
                  <ion-col (click)="updateTicketRating('five')">
                    <ion-icon class="center" [color]="starColor" name="star-outline" *ngIf="!star?.five"></ion-icon>
                    <ion-icon class="center" [color]="starColor" name="star" *ngIf="star?.five"></ion-icon>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </ion-list>
        </div>
      </ng-container>
    </div>
  </ion-content>
  <ion-footer #footer>
    <ion-toolbar *ngIf="!supportTicket?.ticketId">
      <div class="content-div">
        <ion-button class="ion-margin" expand="block" [disabled]="!supportForm?.valid" (click)="supportFormSubmit()">
          {{ 'BTN.confirm' | translate }}
        </ion-button>
      </div>
    </ion-toolbar>
  
    <ng-container  *ngIf="supportTicket?.ticketId">
      <ng-container *ngIf="getSupportAttachmentList() as attachmentList">
        <ion-toolbar *ngIf="attachmentList?.length">
          <div class="content-div">
            <ion-item class="ion-item-no-padding" lines="none">
              <ion-card class="prompt-input-item full-width ion-no-margin">
                <ion-grid fixed>
                  <ion-row>
                    <ion-col size="3" *ngFor="let photo of attachmentList; let i = index;">
                      <div class="attachment-img-div">
                        <ion-button class="attachment-img-btn" (click)="deletePhoto(i);" fill="clear" color="dark">
                          <ion-icon slot="icon-only" name="close"></ion-icon>
                        </ion-button>
                        <ion-img class="attachment-img center" [src]="photo"></ion-img>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </ion-item>
          </div>
        </ion-toolbar>
      </ng-container>
      
      <ion-toolbar class="msg-toolbar" color="white">
        <ion-item class="content-div ion-item-no-padding" lines="none">
          <ion-button class="ion-no-margin" fill="clear" size="large" slot="start" (click)="selectPhoto()">
            <ion-icon slot="icon-only" name="attach-outline"></ion-icon>
          </ion-button>
          <ion-item class="full-width ion-item-no-padding" lines="none">
            <ion-textarea class="text-area full-width" rows="1" [placeholder]="'SUPPORT.lbl.msg_placeholder' | translate " [autoGrow]="true" [(ngModel)]="message">
            </ion-textarea>
          </ion-item>
          <ion-button class="ion-no-margin" fill="clear" size="large" slot="end" (click)="submit()">
            <ion-icon slot="icon-only" name="send"></ion-icon>
          </ion-button>
        </ion-item>
      </ion-toolbar>
    </ng-container>
  </ion-footer>
</ng-template>